import React from 'react';

import { Page } from 'components/_shared/Page';
import { NewGreenhouseSteps } from 'components/NewGreenhouseSteps';

export const NewGreenhouse = props => {
  return (
    <Page fullHeight {...props}>
      <NewGreenhouseSteps />
    </Page>
  );
};
